import Label from "components/Label/Label";
import React, { FC, useEffect, useState } from "react";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";

export interface UserFormProps {
	className?: string;
	user?: any;
	setUser?: any;
	errors?: any;
}

const UserForm: FC<UserFormProps> = ({ user, setUser, errors }) => {
	const [usernameDirty, setUsernameDirty] = useState<boolean>(false);

	useEffect(() => {
		if (!user.id && user.lastName && user.firstName && !usernameDirty) {
			changeUsername();
		}
	}, [user.lastName, user.firstName]);

	const changeUsername = () => {
		setUser({
			...user,
			username: (
				(user.firstName || "").charAt(0) + (user.lastName || "")
			).toLowerCase(),
		});
	};
	return (
		<div className="flex flex-col md:flex-row">
			<div className="flex-grow mt-10 md:mt-0 space-y-6">
				<div className="grid grid-cols-6 gap-4">
					<div className="col-span-2 ">
						<Label>Matricule</Label>
						<Input
							className={
								"mt-1.5" +
								(errors["matricule"] !== undefined ? " border-danger" : "")
							}
							value={user.matricule}
							onChange={({ target }) =>
								setUser({ ...user, matricule: target.value })
							}
						/>
					</div>
				</div>
				<div className="flex flex-col md:flex-row gap-5">
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Nom</Label>
						<Input
							className={
								"mt-1.5" +
								(errors["lastName"] !== undefined ? " border-danger" : "")
							}
							value={user.lastName}
							onChange={({ target }) =>
								setUser({ ...user, lastName: target.value })
							}
						/>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Prénom</Label>
						<Input
							className={
								"mt-1.5" +
								(errors["firstName"] !== undefined ? " border-danger" : "")
							}
							value={user.firstName}
							onChange={({ target }) =>
								setUser({ ...user, firstName: target.value })
							}
						/>
					</div>
				</div>
				<div className="flex flex-col md:flex-row gap-5 items-center">
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Nom d'utilisateur</Label>
						<Input
							className={
								"mt-1.5" +
								(errors["username"] !== undefined ? " border-danger" : "")
							}
							value={user.username}
							onChange={({ target }) => {
								setUsernameDirty(true);
								setUser({ ...user, username: target.value });
							}}
						/>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<div className="flex flex-row justify-between items-center">
							<Label>Mot de passe</Label>
							{/* <ButtonThird sizeClass="py-0.5 px-4 sm:py-0.5 sm:px-6 hover:bg-neutral-100">
								<ArrowPathIcon
									className="w-5 h-5 mr-2 -ml-1"
									aria-hidden="true"
								/>
								Générer
							</ButtonThird> */}
						</div>
						<div className="mt-1.5 flex">
							<span
								className={
									"inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm" +
									(errors["password"] !== undefined ? " border-danger" : "")
								}
							>
								<i className="text-2xl las la-lock"></i>
							</span>
							<Input
								className={
									"!rounded-l-none" +
									(errors["password"] !== undefined ? " border-danger" : "")
								}
								type="password"
								value={user.password}
								onChange={({ target }) =>
									setUser({ ...user, password: target.value })
								}
							/>
						</div>
					</div>
				</div>

				<div className="flex flex-col md:flex-row gap-5">
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Email</Label>
						<Input
							className={
								"mt-1.5" +
								(errors["email"] !== undefined ? " border-danger" : "")
							}
							type="email"
							value={user.email}
							onChange={({ target }) =>
								setUser({ ...user, email: target.value })
							}
						/>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Téléphone</Label>
						<Input
							className={
								"mt-1.5" +
								(errors["phone"] !== undefined ? " border-danger" : "")
							}
							value={user.phone}
							onChange={({ target }) =>
								setUser({ ...user, phone: target.value })
							}
						/>
					</div>
				</div>

				<div className="flex flex-col md:flex-row gap-5">
					{/* <div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Rôle</Label>

						<Select
							className={
								"mt-1.5" +
								(errors["role"] !== undefined ? " border-danger" : "")
							}
							value={user.role}
							onChange={({ target }) =>
								setUser({ ...user, role: target.value })
							}
						>
							<option value=""></option>
							<option value="ADMIN">Administrateur</option>
							<option value="MANAGER">Manager</option>
							<option value="OPERATEUR">Opérateur</option>
						</Select>
					</div> */}
					{/* {user.role != "ADMIN" && ( */}
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Pôle</Label>

						<Select
							className={
								"mt-1.5" +
								(errors["pole"] !== undefined ? " border-danger" : "")
							}
							value={user.pole}
							onChange={({ target }) =>
								setUser({ ...user, pole: target.value })
							}
						>
							<option value=""></option>
							<option value="CONTROLE EXE">CONTROLE EXE</option>
							<option value="CREA">CREA</option>
						</Select>
					</div>
					{/* )} */}
				</div>

				<div className="flex flex-col md:flex-row gap-5 items-center">
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Date d'entrée</Label>
						<Input
							className={
								errors["entryDate"] !== undefined ? " border-danger" : ""
							}
							type="date"
							value={user.entryDate}
							onChange={({ target }) =>
								setUser({ ...user, entryDate: target.value })
							}
						/>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Date de sortie</Label>
						<Input
							className={
								errors["exitDate"] !== undefined ? " border-danger" : ""
							}
							type="date"
							value={user.exitDate}
							onChange={({ target }) =>
								setUser({ ...user, exitDate: target.value })
							}
						/>
					</div>
				</div>

				<div className="flex flex-col md:flex-row gap-5 items-center">
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Heures contrat</Label>
						<div className="mt-1.5 flex">
							<Input
								className={
									errors["contractHours"] !== undefined ? " border-danger" : ""
								}
								value={user.contractHours}
								onChange={({ target }) =>
									setUser({ ...user, contractHours: target.value })
								}
							/>
						</div>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Salaire net</Label>
						<Input
							className={
								errors["netSalary"] !== undefined ? " border-danger" : ""
							}
							value={user.netSalary}
							onChange={({ target }) =>
								setUser({ ...user, netSalary: target.value })
							}
						/>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Montant facturation</Label>
						<div className="mt-1.5 flex">
							<Input
								className={
									errors["invoiceAmount"] !== undefined ? " border-danger" : ""
								}
								value={user.invoiceAmount}
								onChange={({ target }) =>
									setUser({ ...user, invoiceAmount: target.value })
								}
							/>
						</div>
					</div>
				</div>

				<div className="flex flex-col md:flex-row gap-5 items-center">
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Soldes congés initial</Label>
						<div className="mt-1.5 flex">
							<Input
								className={
									errors["soldeCongesInit"] !== undefined
										? " border-danger"
										: ""
								}
								value={user.soldeCongesInit}
								onChange={({ target }) =>
									setUser({ ...user, soldeCongesInit: target.value })
								}
							/>
						</div>
					</div>
					<div className="mt-10 md:mt-0 space-y-1  flex-1">
						<Label>Soldes récup. initial</Label>
						<Input
							className={
								errors["soldeRecupInit"] !== undefined ? " border-danger" : ""
							}
							value={user.soldeRecupInit}
							onChange={({ target }) =>
								setUser({ ...user, soldeRecupInit: target.value })
							}
						/>
					</div>
					{/* <div className="mt-10 md:mt-0 space-y-1  flex-1">
		<Label>Montant facturation</Label>
		<div className="mt-1.5 flex">
			<Input
				className={
					errors["invoiceAmount"] !== undefined ? " border-danger" : ""
				}
				value={user.invoiceAmount}
				onChange={({ target }) =>
					setUser({ ...user, invoiceAmount: target.value })
				}
			/>
		</div>
	</div> */}
				</div>

				<div className="mt-10 md:mt-0 space-y-1 flex-1">
					<Label>Actif / Inactif</Label>

					<Select
						className="mt-1.5"
						value={user.enabled}
						onChange={({ target }) =>
							setUser({ ...user, enabled: target.value })
						}
					>
						<option></option>
						<option value="true">Actif</option>
						<option value="false">Inactif</option>
					</Select>
				</div>
			</div>
		</div>
	);
};

export default UserForm;
